import { Box, Typography, Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import productTypes from "../..";
import ProductCard from "./ProductCard";
import { CustomScrollbar } from "../customScrollbar/CustomScrollbar";
import { setCurrentProduct, selectCurrentProduct } from "../../productSlice";

const Dashboard = () => {
  const dispatch = useDispatch();
  const currentProduct = useSelector(selectCurrentProduct);

  return (
    <Box bgcolor="#f8f8f8" p="1.5em" height={"100vh"} padding={"2rem"}>
      <Typography variant="h3" color="primary" mb="2vh">
        Dashboard
      </Typography>
      <CustomScrollbar>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          maxHeight="70vh"
        >
          {productTypes.map((product, index) => (
            <Grid key={product.id} item>
              <div
                onClick={() => dispatch(setCurrentProduct(product))}
                style={{
                  marginBottom:
                    index === productTypes.length - 1 ? "6vh" : "1rem",
                }}
              >
                <ProductCard
                  product={product}
                  disableSection={product.disableSection}
                  isSelected={product.id === currentProduct?.id}
                />
              </div>
            </Grid>
          ))}
        </Grid>
      </CustomScrollbar>
    </Box>
  );
};

export default Dashboard;
